// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.uploader-example {\n  width: 880px;\n  padding: 15px;\n  margin: 115px 15px 20px;\n  font-size: 12px;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n          box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n}\n.uploader-example .uploader-btn {\n  margin-right: 4px;\n}\n.uploader-example .uploader-list {\n  max-height: 440px;\n  overflow: auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
